import React from "react";
import { Dropdown } from "react-bootstrap";
import PermissionCategoryCard from "./PermissionCategoryCard/PermissionCategoryCard";
import { useRolePermissionsContext } from "../context/RolePermissionsContext";
import { useTranslation } from "react-i18next";

const PermissionModuleSection: React.FC = () => {
    const { t: translate } = useTranslation();
    const { onChangeAllPermissions } = useRolePermissionsContext();
    const { permissions, mode } = useRolePermissionsContext();
    const modules = permissions.modules;
    const isViewMode = mode === "view";

    return (
        <>
            {modules.map((module, moduleIndex) => {
                const isLastModule = moduleIndex === modules.length - 1;
                const isBaseModule = module.code === "base";
                const moduleTitle = isBaseModule ? translate("Access permissions settings") : module.label;

                return (
                    <div key={`${module.code}-${module.order}`} className={!isLastModule ? "mb-4" : ""}>
                        <div className="d-flex align-items-center justify-content-between mb-4">
                            <h4 className={isBaseModule ? "fw-normal" : "fw-bold fs-5"}>{moduleTitle}</h4>

                            {isBaseModule && !isViewMode && (
                                <Dropdown align="end" drop="down">
                                    <Dropdown.Toggle as="div" className="custom-toggle p-0 cursor-pointer">
                                        <i className="bi bi-three-dots-vertical fs-5"></i>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="module-actions-dropdown">
                                        <Dropdown.Item onClick={() => onChangeAllPermissions(true)}>
                                            <i className="bi bi-check-lg me-2"></i>
                                            {translate("Grant all permissions")}
                                        </Dropdown.Item>

                                        <Dropdown.Item onClick={() => onChangeAllPermissions(false)}>
                                            <i className="bi bi-x-lg me-2"></i>
                                            {translate("Revoke all permissions")}
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            )}
                        </div>

                        {module.categories.map((category, categoryIndex) => {
                            const isLastCategory = categoryIndex === module.categories.length - 1;

                            return (
                                <PermissionCategoryCard
                                    key={`${category.code}-${category.order}`}
                                    className={!isLastCategory ? "mb-4" : ""}
                                    category={category}
                                    moduleCode={module.code}
                                />
                            );
                        })}
                    </div>
                );
            })}
        </>
    );
};

export default React.memo(PermissionModuleSection);
